import { observer } from "mobx-react";
import {
  PortfolioSearchState,
  QUICK_SWITCHER_SHORTCUT_KEY,
  QuickSwitcherContext,
  quickSwitcherItems,
  setQuickSwitcherOpen,
} from "./portfolioSearchDomain";
import { FC, useEffect, useMemo } from "react";
import { isCmdOrCtrlShortcut } from "@/utils/keyboard";
import { QuickSwitcherDialog } from "./portfolioSearchComponents";

export type QuickSwitcherProps = {
  state: PortfolioSearchState | undefined;
  context: QuickSwitcherContext;
};

export const QuickSwitcher: FC<QuickSwitcherProps> = observer(({ state, context }) => {
  const { dispatch } = context;
  const items = useMemo(
    () => quickSwitcherItems(state?.overview, context.portfolio),
    [state?.overview, context.portfolio],
  );

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (isCmdOrCtrlShortcut(event, QUICK_SWITCHER_SHORTCUT_KEY)) {
        event.preventDefault();
        dispatch([setQuickSwitcherOpen(true)]);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [dispatch]);

  return items.length === 0 ? null : (
    <QuickSwitcherDialog state={state} context={context} items={items} />
  );
});
